import Logger from '../logger';
import { ERROR_MAP, STR_SEARCH_KEY, ERROR_REPLACE_TEXT } from '../../constants';

const filterDbError = (message) => {
  if (message.indexOf(STR_SEARCH_KEY.OLD_EMAIL_ERROR) >= 0) {
    return ERROR_REPLACE_TEXT.OLD_EMAIL_ERROR;
  }
  return ERROR_REPLACE_TEXT.GENERIC_DB_ERROR;
};

const isCustomDbError = (desc) => {
  return desc.indexOf(STR_SEARCH_KEY.DB_CUSTOM_ERROR) >= 0;
};

const isUserExistsError = (desc) => {
  return desc.indexOf(STR_SEARCH_KEY.USER_EXISTS_ERROR) >= 0;
};

const isPasswordError = (desc) => {
  return desc.indexOf(STR_SEARCH_KEY.PASSWORD_ERROR) >= 0;
};

export default {
  parse(error) {
    if (error != null && typeof error === 'object') {
      const { description, code, name } = error;

      // do note that we are not capturing
      // error.message
      // which means any error caught
      // from new Error()
      // will render the generic message
      // 'Error occured. Please try again.'
      // to user
      // if we enable error.message
      // it might be too technical for user

      // error response from API call
      // return description if its string
      if (description && typeof description === 'string') {
        if (isCustomDbError(description)) {
          return filterDbError(description);
        }
        if (isUserExistsError(description)) {
          return ERROR_REPLACE_TEXT.USER_EXISTS_ERROR;
        }
        if (isPasswordError(description)) {
          return ERROR_REPLACE_TEXT.PASSWORD_ERROR;
        }
        return description;
      }

      // else try to decode error from code and name
      let errorMessage = ERROR_MAP[code];
      const errorName = ERROR_MAP[name];
      if (errorName) {
        errorMessage += ` ${errorName}`;
      }

      // if still error is empty then log desc error obj
      if (description != null && typeof description === 'object') {
        Logger.error(error);
      }

      if (!errorMessage) {
        errorMessage = 'Error occured. Please try again.';
      }

      return errorMessage;
    }
    return error;
  },
};
